import { useLoaderData, useRouteError } from "react-router-dom";
import GenericErrorDisplay from "../generic-error";
import TransmedProcessService from "../../service/transmed/process";
import TransmedReceivingService from "../../service/transmed/process/receiving";
import TransmedReceiving from "../../dtos/transmed/process/receiving";
import TransmedDistributionService from "../../service/transmed/process/distribution";
import { TransmedReceivingDetailWithProblems } from "../../dtos/transmed/process/receivingDetail";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faInfinity,
} from "@fortawesome/free-solid-svg-icons";

export const path = "transmed/distribution";

export async function loader() {
  const details = new TransmedDistributionService().read.mine();

  const edition = await new TransmedProcessService().read.edition();
  let receivings: TransmedReceiving[] = [];
  if (edition.process_started)
    receivings = await new TransmedReceivingService().read.all();

  return [await details, receivings];
}

export function Component() {
  const [details, receivings] = useLoaderData() as [
    TransmedReceivingDetailWithProblems[],
    TransmedReceiving[]
  ];

  return (
    <>
      <h1 style={{ marginBottom: "var(--gap-big)", wordBreak: "break-word" }}>
        Distribuție transmed
      </h1>
      <p>Urmărește distribuția locurilor rămase disponibile către celelalte centre.</p>
      <div
        style={{
          marginTop: "var(--gap-medium)",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-evenly",
          gap: "var(--gap-small)",
        }}
      >
        {details.map((receivingDetails) => (
          <div
            key={receivingDetails.id}
            className="surface"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "var(--gap-small)",
            }}
          >
            <h4>
              {receivings.find(
                (r: TransmedReceiving) => r.lc.id === receivingDetails.receiver
              )?.lc.city ?? "Necunoscut"}
            </h4>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "var(--gap-small)",
              }}
            >
              <button
                type="button"
                disabled={true}
                className="button primary text"
                style={{
                  backgroundColor:
                    (receivingDetails.accomodation_yes ?? 1) > 0
                      ? "var(--color-overlay)"
                      : undefined,
                  color: "var(--color-dark)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span>Cu cazare</span>
                <b
                  style={{
                    fontWeight: 600,
                    marginTop: "var(--gap-xs)",
                    fontSize: "var(--body-font-size)",
                    color:
                      (receivingDetails.accomodation_yes ?? 1) > 0
                        ? receivingDetails.warning_yes
                          ? "yellow"
                          : "var(--color-fasmr-blue)"
                        : "var(--color-dark)",
                  }}
                >
                  {receivingDetails.warning_yes && (
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      color="yellow"
                    />
                  )}{" "}
                  {receivingDetails.accomodation_yes ?? (
                    <FontAwesomeIcon icon={faInfinity} />
                  )}
                </b>
              </button>
              <button
                type="button"
                disabled={true}
                className="button primary text"
                style={{
                  backgroundColor:
                    (receivingDetails.accomodation_no ?? 1) > 0
                      ? "var(--color-overlay)"
                      : undefined,
                  color: "var(--color-dark)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span>Fără cazare</span>
                <b
                  style={{
                    fontWeight: 600,
                    marginTop: "var(--gap-xs)",
                    fontSize: "var(--body-font-size)",
                    color:
                      (receivingDetails.accomodation_no ?? 1) > 0
                        ? receivingDetails.warning_no
                          ? "yellow"
                          : "var(--color-fasmr-blue)"
                        : "var(--color-dark)",
                  }}
                >
                  {receivingDetails.warning_no && (
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      color="yellow"
                    />
                  )}{" "}
                  {receivingDetails.accomodation_no ?? (
                    <FontAwesomeIcon icon={faInfinity} />
                  )}
                </b>
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
Component.displayName = "page-account-transmed-distribution";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-account-transmed-distribution-error";
